import type { RootState } from "single-spa/store/types";

export const selectSelectedBenchmark = (state: RootState) =>
    state.benchmarkTracker.benchmarkEntityReducer.selectedBenchmark;

export const selectIsBenchmarkFetched = (state: RootState) =>
    state.benchmarkTracker.benchmarkEntityReducer.isBenchmarkFetched;
